import React, { useState } from "react"
import { HouseholdWithStatus } from "../../../../api/graphql/queries/household-statuses"
import { InfoWindow, Marker } from "@react-google-maps/api"
import { HouseholdMarkerInfoWindowContent } from "./household-marker-info-window-content"
import { Clusterer } from "@react-google-maps/marker-clusterer"

interface IHouseholdMarkerProps {
  household: HouseholdWithStatus
  clusterer: Clusterer
}

export const HouseholdMarker: React.FC<IHouseholdMarkerProps> = (props) => {
  const { household, clusterer } = props

  const [isOpen, setIsOpen] = useState<boolean>(false)

  return (
    <Marker
      position={{ lat: household.latitude, lng: household.longitude }}
      clusterer={clusterer}
      onClick={() => {
        setIsOpen(true)
      }}
      icon={{
        fillColor: household.status.color,
        fillOpacity: 0.75,
        scale: 1,
        strokeWeight: 3,
        strokeColor: household.status.color,
        path: "M-10,0a10,10 0 1,0 20,0a10,10 0 1,0 -20,0",
      }}
    >
      {isOpen && (
        <InfoWindow onCloseClick={() => setIsOpen(false)} onUnmount={() => setIsOpen(false)}>
          {<HouseholdMarkerInfoWindowContent household={household} />}
        </InfoWindow>
      )}
    </Marker>
  )
}
